import React from 'react';
import './button.css';

function MyButton({ initialText }) {
  return (
    <button className='transparent-button first-font font-size-xsmall button-gap hover-pointer'>{initialText}</button>
  );
}

export default MyButton;